import React from 'react';
import { CustomContentInfo } from './types';
import styles from './inforequest.module.scss';

const InfoRequestDropDown: React.FC<CustomContentInfo> = ({
  description,
  options
}) => {
  const handleRequestSelected = (target: string) => {
    window.location.replace(target);
  };

  return (
    <div className={styles.infoRequestDropDown}>
      <h4>{description}</h4>
      <div>
        <select
          onChange={e => {
            handleRequestSelected(e.target.value);
          }}
        >
          <option value="">Please select an option</option>
          {options.map(x => (
            <option key={x.id} value={x.url}>
              {x.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default InfoRequestDropDown;
